module.exports = __webpack_public_path__ + "media/promo/courses/images/access3-7c8edac5ccd6eba1f636c736267ac320.jpg";